export default ({ request }) => ({
  dfInspectionApplyListApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/list',
      method: 'post',
      data,
    })
  },
  dfInspectionApplyDetailApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/detail',
      method: 'post',
      data,
    })
  },
  dfInspectionApplySaveApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/save',
      method: 'post',
      data,
    })
  },
  dfInspectionApplySubmitApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/submit',
      method: 'post',
      data
    })
  },
  dfInspectionApplyDelApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/del',
      method: 'post',
      data,
    })
  },
  dfInspectionApplyAuditApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/audit',
      method: 'post',
      data,
    })
  },
  dfInspectionProductOrderGoodsListApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/orderGoods/list',
      method: 'post',
      data,
    })
  },
  dfInspectionProductDetailApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/detail',
      method: 'post',
      data,
    })
  },
  dfInspectionProductSaveApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/save',
      method: 'post',
      data,
    })
  },
  dfInspectionProductDelApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/del',
      method: 'post',
      data,
    })
  },
  dfInspectionProductDetailSaveApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/detail/save',
      method: 'post',
      data,
    })
  },
  dfInspectionProductDetailListApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/detail/list',
      method: 'post',
      data,
    })
  },
  dfInspectionProductDetailDelApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/detail/del',
      method: 'post',
      data,
    })
  },
  dfInspectionApplyDocListApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/doc/list',
      method: 'post',
      data,
    })
  },
  dfInspectionApplyDocSaveApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/doc/save',
      method: 'post',
      data,
    })
  },
  dfInspectionApplyDocDelApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/apply/doc/del',
      method: 'post',
      data,
    })
  },
  dfInspectionProductListApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/list',
      method: 'post',
      data,
    })
  },
  dfInspectionProductDetailReportListApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/detail/reportList',
      method: 'post',
      data,
    })
  },
  dfInspectionProductDetailReportSaveApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/detail/reportSave',
      method: 'post',
      data,
    })
  },
  dfInspectionProducImageSaveApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/image/save',
      method: 'post',
      data,
    })
  },
  dfInspectionProductImageDelApi(data = {}) {
    return request({
      url: '/dfs/df/inspection/product/image/del',
      method: 'post',
      data,
    })
  },
})
